import axiosToken from "../components/social-wallet/AxiosToken";

// ── MCP Config ──────────────────────────────────────────────
export async function getMcpConfig(keyPrefix) {
  const res = await axiosToken.get("mcp/config", {
    params: keyPrefix ? { key_prefix: keyPrefix } : {},
  });
  return res.data;
}

export async function updateMcpConfig(updates, keyPrefix) {
  const res = await axiosToken.put("mcp/config", {
    ...updates,
    ...(keyPrefix ? { key_prefix: keyPrefix } : {}),
  });
  return res.data;
}

// ── Spending & Audit ────────────────────────────────────────
export async function getMcpSpending() {
  const res = await axiosToken.get("mcp/spending");
  return res.data;
}

export async function getMcpAudit(limit = 50, offset = 0) {
  const res = await axiosToken.get("mcp/audit", {
    params: { limit, offset },
  });
  return res.data;
}

// ── HNS ─────────────────────────────────────────────────────
export async function getHnsProfile(walletIndex = 0) {
  const res = await axiosToken.get("mcp/hns/profile", {
    params: { wallet_index: walletIndex },
  });
  return res.data;
}

export async function setHnsName(username, displayName, walletIndex = 0) {
  const res = await axiosToken.post("mcp/hns/set-name", {
    username,
    display_name: displayName,
    wallet_index: walletIndex,
  });
  return res.data;
}

export async function releaseHnsName(walletIndex = 0) {
  const res = await axiosToken.post("mcp/hns/release", {
    wallet_index: walletIndex,
  });
  return res.data;
}

export async function resolveHnsName(name) {
  // Normalize plain usernames to @username for HNS resolution
  let normalized = name.trim();
  if (
    !normalized.startsWith("@") &&
    !normalized.startsWith("0x") &&
    !normalized.includes(".") &&
    /^[a-zA-Z][a-zA-Z0-9_-]*$/.test(normalized)
  ) {
    normalized = `@${normalized}`;
  }
  // username.horus → @username
  if (normalized.toLowerCase().endsWith(".horus")) {
    normalized = `@${normalized.slice(0, -6)}`;
  }
  const res = await axiosToken.get("mcp/hns/resolve", {
    params: { name: normalized },
  });
  return res.data;
}

export async function reverseHnsLookup(addresses) {
  const res = await axiosToken.post("mcp/hns/reverse-lookup", { addresses });
  return res.data; // { names: { "0x...": { username, display_name } } }
}

// ── API Keys ────────────────────────────────────────────────
export async function listWalletsForKey() {
  const res = await axiosToken.get("mcp/keys/wallets");
  return res.data;
}

export async function generateMcpKey(params) {
  const res = await axiosToken.post("mcp/keys/generate", params);
  return res.data;
}

export async function listMcpKeys() {
  const res = await axiosToken.get("mcp/keys");
  return res.data;
}

export async function revokeMcpKey(keyId) {
  const res = await axiosToken.delete(`mcp/keys/${keyId}`);
  return res.data;
}

export async function updateMcpKey(keyId, updates) {
  const res = await axiosToken.put(`mcp/keys/${keyId}`, updates);
  return res.data;
}
